import { useDispatch, useSelector } from 'react-redux';
import {
  Fragment, memo, useCallback, useEffect
} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuHidden
} from '../../../../store/layout';

import { useThemeContext } from '../../../../utility/context/ThemeColors';

function LayoutWrapper({ children, routeMeta }) {
  const { themeConfig } = useThemeContext();
  // ** Store Vars
  const dispatch = useDispatch();
  const store = useSelector((state) => state);

  const navbarStore = store.navbar;
  const layoutStored = store.layout.layout;

  //* * Vars
  const appLayoutCondition = (layoutStored.layout === 'horizontal' && !routeMeta)
    || (layoutStored.layout === 'horizontal' && routeMeta && !routeMeta.appLayout);
  const Tag = appLayoutCondition ? 'div' : Fragment;

  // ** Clean Up Function
  const cleanUp = useCallback(
    () => {
      if (routeMeta) {
        if (
          routeMeta.contentWidth
          && routeMeta.contentWidth === store.layout.contentWidth
        ) {
          dispatch(handleContentWidth(themeConfig.layout.contentWidth));
        }
        if (
          routeMeta.menuCollapsed
          && routeMeta.menuCollapsed === store.layout.menuCollapsed
        ) {
          dispatch(handleMenuCollapsed(!store.layout.menuCollapsed));
        }
        if (
          routeMeta.menuHidden
          && routeMeta.menuHidden === store.layout.menuHidden
        ) {
          dispatch(handleMenuHidden(!store.layout.menuHidden));
        }
      }
    },
    [
      dispatch,
      routeMeta,
      store.layout.contentWidth,
      store.layout.menuCollapsed,
      store.layout.menuHidden
    ]
  );

  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth));
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed));
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden));
      }
    }
    return () => cleanUp();
  }, [cleanUp, dispatch, routeMeta]);

  return (
    <div
      className={classnames('app-content content overflow-hidden', {
        [routeMeta ? routeMeta.className : '']:
        routeMeta && routeMeta.className,
        'show-overlay': navbarStore.query.length
      })}
    >
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          'content-wrapper': routeMeta && !routeMeta.appLayout,
          'content-area-wrapper': routeMeta && routeMeta.appLayout,
          'container-xxl p-0': true // contentWidth === 'boxed'
        })}
      >
        <Tag {...(appLayoutCondition ? { className: 'content-body' } : {})}>
          {children}
        </Tag>
      </div>
    </div>
  );
}

LayoutWrapper.propTypes = {
  children: PropTypes.node,
  routeMeta: PropTypes.shape({
    contentWidth: PropTypes.string,
    menuCollapsed: PropTypes.bool,
    menuHidden: PropTypes.bool,
    className: PropTypes.string,
    appLayout: PropTypes.any
  })
};
export default memo(LayoutWrapper);
